module.exports = __webpack_public_path__ + "static/media/navBarIconProjects.a11cc6b3.svg";